// src/data/sliderData.js

export const sliderData = [
    {
      title: "Dlaczego warto nas wybrać?",
      description: "W salonie fryzjerskim \"u Małgosi\" dbamy nie tylko o piękno Twoich włosów, ale też o wyjątkowe doświadczenie podczas każdej wizyty.",
      buttonText: "Dowiedz się więcej",
      bgColor: "bg-[#35094c]",
      accentColor: "bg-[#7b29aa]",
      buttonBg: "bg-[#9333ea]"
    },
    {
      title: "Profesjonalizm",
      description: "Nasz zespół to doświadczeni styliści fryzur, regularnie uczestniczący w szkoleniach, by być na bieżąco z najnowszymi trendami w świecie fryzjerstwa.",
      buttonText: "Poznaj nas",
      bgColor: "bg-[#2b0a3d]",
      accentColor: "bg-[#6b21a8]",
      buttonBg: "bg-[#8b5cf6]"
    },
    {
      title: "Najwyższa jakość",
      description: "Używamy wyłącznie profesjonalnych kosmetyków renomowanych marek, dbając o zdrowie i piękno Twoich włosów. Twoja satysfakcja jest naszym priorytetem.",
      buttonText: "Zobacz produkty",
      bgColor: "bg-[#3b0764]",
      accentColor: "bg-[#7e22ce]",
      buttonBg: "bg-[#a855f7]"
    },
    {
      title: "Indywidualne podejście",
      description: "Każda klientka i klient są dla nas wyjątkowi. Dopasowujemy fryzurę do Twojego stylu, kształtu twarzy i osobowości, by podkreślić Twoje naturalne piękno.",
      buttonText: "Umów wizytę",
      bgColor: "bg-[#4a044e]",
      accentColor: "bg-[#8e24aa]",
      buttonBg: "bg-[#c026d3]"
    },
    {
      title: "Przyjazna atmosfera",
      description: "Wizyta u fryzjera powinna być przyjemnością. Zadbamy, byś czuł się komfortowo w miłej i relaksującej atmosferze. Twoje zadowolenie jest naszym priorytetem.",
      buttonText: "Zarezerwuj termin",
      bgColor: "bg-[#300050]",
      accentColor: "bg-[#8b18da]",
      buttonBg: "bg-[#9333ea]"
    }
  ];